const CART_MUTATION_FAILURE_MESSAGE = 'Unable to update your shopping cart.'

export function assertCartMutationSucceeded(
  succeeded: boolean | null | undefined
): asserts succeeded is true {
  if (succeeded !== true) {
    throw new Error(CART_MUTATION_FAILURE_MESSAGE)
  }
}
